export function formatNumber(num) {
    const formatter = new Intl.NumberFormat('en-US', {
        notation: 'compact',
        compactDisplay: 'short'
    });
    return formatter.format(num);
}